export default "assets/images/icons/slider-arrow-edae25f2.svg";